export const DRAFT_USER_NAME = "demouser";
export const API_BASE = `https://tdd.demo.reaktivate.com/v1/books/${DRAFT_USER_NAME}`;
